import React from 'react';
import PropTypes from 'prop-types';
import sessionProp from '../propTypes/sessionProp';
import translate from '../../../commonComponents/translate';
import { resolveDocumentUrl } from '../../../services/utilityFunctions';

function WebinarDocuments({ t, session, documentColumnClass, showImage }) {
  const { documents } = session;
  return (
    <>
      <div className="webinar-documents">
        {documents.length > 0 &&
        <div>
          <span className="webinar-title-info">
            {showImage && (
              <img
                src="/images/academy/session/folder-session.svg"
                alt="Folder"
              />
            )}
            <span className="webinar-title-info-title">
              {t('sessionDetails.location.documents')}
            </span>
          </span>
          <span className="webinar-documents-holder row">
          {
            Object.keys(documents).map(item => (
              <div className={`${documentColumnClass} session-pdf`}>
                <div className="user-holder">
                  <div className="user-img">
                    <div className="user-check">
                      <a
                        href={resolveDocumentUrl(documents[item].file.url)}
                        target="_blank"
                        style={{ textDecoration: 'none' }}
                        rel="noopener noreferrer"
                      >
                        <i id="icon" className="la la-download" />
                      </a>
                    </div>
                    <div className="user-pic">
                      <img
                        src="/images/academy/session/pdf-session.svg"
                        alt="Pdf"
                      />
                    </div>
                  </div>
                  <p className="user-name">{documents[item].file.originalName}</p>
                </div>
              </div>
            ))
          }
          </span>
        </div>
        }
      </div>
    </>
  );
}

WebinarDocuments.propTypes = {
  t: PropTypes.func.isRequired,
  session: PropTypes.shape(sessionProp.propType).isRequired,
  documentColumnClass: PropTypes.string,
  showImage: PropTypes.bool,
};

WebinarDocuments.defaultProps = {
  documentColumnClass: 'col-lg-6 col-6',
  showImage: true,
};

export default translate(WebinarDocuments);
